import axios from 'axios'
import qs from 'qs'

export const masterTopicService = ({
  getAllMasterTopicList (token) {
    return axios.get('/api/MasterTopic', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createMasterTopic (token, topicObj) {
    return axios.post('/api/MasterTopic/Create', topicObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMasterTopic (token, topicObj) {
    var stringifiedObj = qs.stringify(topicObj)
    return axios.put('/api/MasterTopic/Update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteMasterTopic (token, masterTemplateId) {
    return axios.delete('/api/MasterTopic?masterTopicId=' + masterTemplateId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/master-topic-service.js